<template>
    <ContractUserProfileTable></ContractUserProfileTable>
</template>
  
  <script>

  import ContractUserProfileTable from "./UserContractsTable.vue"; 

  export default {
    components: {
      ContractUserProfileTable
    }, 
    data() {return{};},
    created() {},
    computed: {},
    methods: {},
  };
  </script>
  
  <style scoped></style>
  